import React from 'react';

import DeviceSelector from '../DeviceSelector/DeviceSelector';

const NewDevice: React.FC = () => <DeviceSelector type="controller" />;

export default NewDevice;
